import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import colors from '../../../styling/colors';
import button from '../../../styling/mixins/button';

const OutlineButton = styled.button`
  ${button} background-color: transparent;
  border-color: ${({ color }) => colors(color)};
  border-radius: ${({ borderRadius }) => borderRadius};
  color: ${({ color }) => colors(color)};

  @media (hover: hover) {
    &:hover {
      background-color: ${({ color }) => colors(color)};
      color: ${({ color }) => (color === 'white' ? colors('lapel') : 'white')};
    }
  }
`;

OutlineButton.propTypes = {
  borderRadius: PropTypes.string,
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

OutlineButton.defaultProps = {
  borderRadius: '0',
  color: 'lapel',
};

OutlineButton.displayName = 'OutlineButton';

export default OutlineButton;
